// extracted by mini-css-extract-plugin
module.exports = {"root":"UploaderFileList_root__3Txd1","list":"UploaderFileList_list__3d7-f"};